import { createSelector } from 'reselect/lib/index';
import { get } from 'lodash';
import { ACTIVITY_TYPES } from '../../../constants';

export const selectActivitiesState = state =>
  get(state, 'communities.activities');

export const selectActivitiesActiveTab = createSelector(
  selectActivitiesState,
  state => get(state, 'activeTab'),
);

export const selectJoinReqState = state =>
  get(state, 'communities.communitiesJoinRequests');

export const selectActivitiesList = createSelector(
  selectActivitiesActiveTab,
  selectJoinReqState,
  (tab, state) => get(state, tab, []),
);

export const selectActivityListByType = type =>
  createSelector(
    selectJoinReqState,
    state => get(state, type, []),
  );

export const selectActivitiesMetaState = createSelector(
  selectJoinReqState,
  state => get(state, 'meta', {}),
);

export const selectActivityCounterByType = type =>
  createSelector(
    selectActivitiesMetaState,
    meta => get(meta, [type, 'total']),
  );

export const selectActivityMetaByType = type =>
  createSelector(
    selectActivitiesMetaState,
    meta => get(meta, type),
  );

export const selectIsActivitiesNotEmpty = createSelector(
  selectActivityCounterByType(ACTIVITY_TYPES.JOIN_REQUESTS),
  selectActivityCounterByType(ACTIVITY_TYPES.MEMBER_INVITATIONS),
  selectActivityCounterByType(ACTIVITY_TYPES.NOTIFICATIONS),
  (requestsCounter, notificationCounter, invitationCounter) =>
    Boolean(requestsCounter || notificationCounter || invitationCounter),
);



// WEBPACK FOOTER //
// ./src/redux/communities/selectors/activitiesSelector.js